import React from 'react'

export default function Footer() {
    const mode = localStorage.getItem('mode')
    return (
        <>
        {mode==='dark'?
        <div style={{backgroundColor:'black',color:'white', textAlign:'center'}}>
        <span style={{fontSize:'2vh'}}>Made By <a href='https://www.linkedin.com/in/adriandsouza/' style={{color:'white'}}><b>Adrian D'Souza</b> </a></span><br/>
        <span style={{fontSize:'1.5vh'}}>Powered By <a href='https://www.coingecko.com/en' style={{color:'white'}} ><b>CoinGecko</b></a></span>
        </div>
        :
        <>
        <div style={{backgroundColor:'white',color:'#4717f6', textAlign:'center'}}>
        <span style={{fontSize:'2vh'}}>Made By <a href='https://www.linkedin.com/in/adriandsouza/' style={{color:'#4717f6'}}><b>Adrian D'Souza</b></a></span><br/>
        <span style={{fontSize:'1.5vh'}}>Powered By <a href='https://www.coingecko.com/en' style={{color:'#4717f6'}} ><b>CoinGecko</b></a></span>
        </div>
        </>
        }
        </>
    )
}
